import { renderAlert } from "../../../CommonComponents/Alert/Alert";
import { CustomDropdownEditor } from "../cellComponents/Dropdown/CustomDropdownEditor";
import { CustomDropdownFilter } from "../cellComponents/Dropdown/CustomDropdownFilter";
import { CustomDropdownRenderer } from "../cellComponents/Dropdown/CustomDropdownRenderer";
import { CustomDateFilter } from "../cellComponents/Filters/CustomDateFilter";
import { CustomTextNumberFilter } from "../cellComponents/Filters/CustomTextNumberFilter";
import { CustomCellEditor } from "../components/Grid/CustomCellEditor";
import CustomCellRenderer, { IndicatorRenderer } from "../components/Grid/CustomCellRenderer";
import { CustomDateCellEditor } from "../components/Grid/CustomDateCellEditor";
import { CustomDateRenderer } from "../components/Grid/CustomDateRenderer";
import { getIndentClass } from "../components/Grid/gridHelperFunctions";
import { makeColumnArrayForDB } from "./callbackHelper";
import { addRowToParentList, getParentDateAsPredecessor, processListValues, getParentValueAsPredecessor, getParentValueAsRollUp, getParentDateAsRollUp, generateListDataForRollupStatus, getParentValueAsStatus, calculateDuration, getCellStyle, SetTimeSeriesColumnProperties, SetTotalTimeSeriesColumnProperties, getParentValueAsRollupStatus, processDuration, HighlightBasedOnTimeRange, updateMDVRollUpValue, checkIfAvgRollUpFieldExistsAndUpdate, sanitizeColumnDefs, findDate, processAndPush, determineParentRollupStatus, updateMDVRollUpValueAddNewProp } from "./helperFunctions";
import React from 'react';
import { checkAndUpDateValueAccordingToColumnType, deepCopy, handleLinkedColumns, makeParentCellNotEditable, updatedPredecessorCellValue } from "./helpersSubModule";
import { CustomPredecessorRenderer } from "../cellComponents/Predecessor/CustomPredecessorRenderer";
import CustomPredecessorEditor from "../cellComponents/Predecessor/PredecessorEditor";
import MultiDimensionalCustomColumn from "../cellComponents/FushionColumn/MultiDimensionalColumnRenderer";
import MultiDimensionalValueTypeEditor from "../cellComponents/FushionColumn/MultiDimensionalValueTypeEditor";
import { addSharedList } from "../../../redux/action/userActivityAction";
import { CustomNumberRenderer } from "../components/Grid/CustomNumberRenderer";
import XTABLES_ACTION_TYPES from "../redux/xTablesReduxActionTypes";
import xTablesStore from "../redux/xTablesStore";
import { checkIfRollupEnabledInMDV, returnRollUpFields, updateCellValue } from "./xTablesHelper";
import { categorizeAndStoreUpdatedRows } from "../redux/action/gridAction";
import {  updateCheckInAgentDataFromSheetAndSaveInSheet } from "../../../redux/action/sheetAction";
import { getSheetCheckInAgentData } from "../../../helpers/helper";
let hasShownAlert = false; // Global flag

export const addEmptyRows = (rows) => {
    for (let i = 1; i <= 20; i++) {
        let row = null;
        rows.push(row);
    }
    return rows;
}
const updateRowD = ({params, newVal, data, rowIndex, colId, gridRef, onCellValueChanged, field, callBack}) => {
    let updateParams = {...params}
    updateParams.data=  updateParams.node.data
    let row = data
    if (newVal?.$d) newVal = new Date(newVal)
    row[field] = newVal
    if (params.colDef.type === 'person' || params.colDef.type === 'Assignee') {
        updateParams.value = newVal
    }
    
    onCellValueChanged(updateParams, { newVal, sheetRowId: row.id, row, columnId: colId })
    if(callBack) callBack();
}

export const formatColumnsFromElastic = (row, colIdObj) => {

    Object.keys(colIdObj).forEach((colId) => {
        if (row[colId]) {
            let colname = colIdObj[colId].field
            row[colname]=checkAndUpDateValueAccordingToColumnType(colIdObj[colId],row[colId].value,row);
        }
    })
    return row
}
export const syncLidWithId = (row) => {
    if (row.l_id && row.l_id.includes('.')) {
        let newl_id = row.l_id.split('.')
        newl_id[newl_id.length - 1] = row.id
        newl_id = newl_id.filter((l_id) => l_id != '')
        return newl_id.join('.')
    }
    else return row.id
}
export const formatRow=(row,colIdObj)=> {
    let id = row.id
    row["id"] = id;
    row["l_id"] = row.l_id || id;
    row['style'] = row['style'] || {}
    row = formatColumnsFromElastic(row, colIdObj)
    row.l_id = syncLidWithId(row)
    return row
}
export const formatRows = async (sheetDataListFromDB, setRowData, colIdObj, parentList, setParentList, setChildrenListObject) => {
    let rowDataFromDB = [];
    let rowsobject = {}
    let parentRowsList = []
    sheetDataListFromDB.forEach(function (sheetData, index) {
        if (sheetData) {
            let row = typeof sheetData == 'string' ? JSON.parse(sheetData) : sheetData;
            if(!rowsobject[row.id]){
                let id = sheetData?.id
                row["id"] = id;
                row["rowindex"] = row.rowindex;
                row["#"] = index + 1;
                row["l_id"] = row.l_id || id;
                row["parent_id"] = row.parent_id;
                row['style'] = row['style'] || {}
                row = formatColumnsFromElastic(row, colIdObj)
                if (row.l_id?.includes(".")) {
                    parentRowsList = addRowToParentList(row.l_id, parentRowsList, setParentList);
                }
                row.l_id = syncLidWithId(row)
                rowsobject[id] = row
                rowDataFromDB.push(row);
            }
           
        }
    });
    setParentList(parentRowsList)
    if (sheetDataListFromDB && sheetDataListFromDB.length) {
        const rowDataFromDBClone = JSON.parse(JSON.stringify(rowDataFromDB));
        setRowData({ rows: rowDataFromDBClone, rowsObject: rowsobject })

    } else {
        //let emptyRowData = addEmptyRows([]);
        setRowData({ rows: [], rowsObject: {} })
    }
}
export const getParsedJSONObject = (object) => {
    try {
        return JSON.parse(object)
    } catch (error) {
        console.warn("Error parsing JSON oject:", error)
        return object
    }
}
export const myComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {

    if (valueA == valueB) return 0;
    if ((valueA === null || valueA === undefined || valueA === '') && valueB) {
        return isInverted ? -1 : 1; // Prefer valueB in descending order
    }
    if (valueA && (valueB === null || valueB === undefined || valueB === '')) {
        return isInverted ? 1 : -1; // Prefer valueB in ascending order
    }
    return (valueA > valueB) ? 1 : -1;

};
export const NumberComparator = (valueA, valueB, nodeA, nodeB, isInverted) => {

    if (valueA == valueB) return 0;

    if ((valueA === null || valueA === undefined || valueA === '') && valueB) {
        return isInverted ? -1 : 1; // Prefer valueB in descending order
    }
    if (valueA && (valueB === null || valueB === undefined || valueB === '')) {
        return isInverted ? 1 : -1; // Prefer valueB in ascending order
    }
    return (parseFloat(valueA) - parseFloat(valueB))

};
export const DateComparator = (dateString1, dateString2, nodeA, nodeB, isInverted) => {

    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    // Compare the two Date objects
    if (date1 < date2) {
        return -1;
    } else if (date1 > date2) {
        return 1;
    } else {
        return 0; // Dates are equal
    }

};


export const findtheFirstParentOfNode=(node)=>{
    if(node.parent.id=='ROOT_NODE_ID') return node.childIndex+1
    else return findtheFirstParentOfNode(node.parent) + "."+parseInt(node.childIndex+1)
}

export function updateItemFromMatchingProp(item, matchingProp) {
    let updatedItem = {
        ...item,
        propName: matchingProp.propName,
        propType: matchingProp.propType,
        propAbbrevation: matchingProp.propAbbrevation,
        propId: matchingProp.propId,
        propBgColor: matchingProp.propBgColor,
        propFgColor: matchingProp.propFgColor,
    };

    if (['multi-list', 'single-list'].includes(matchingProp.propType)) {
        updatedItem.propList = matchingProp.propList;

        if (matchingProp.propType === 'multi-list' && Array.isArray(updatedItem.propValue)) {
            updatedItem.propValue = updatedItem.propValue.filter(val =>
                matchingProp.propList?.includes(val)
            );
        }

        if (matchingProp.propType === 'single-list' && typeof updatedItem.propValue === 'string') {
            if (!matchingProp.propList?.includes(updatedItem.propValue)) {
                updatedItem.propValue = '';
            }
        }
    }

    if (item.propType !== matchingProp.propType) {
        delete updatedItem.propValue;
    }

    return updatedItem;
}

export function updateItemFromExistingProp(item, updateExistingProperty) {
    return {
        ...item,
        propName: updateExistingProperty.propName,
        propType: updateExistingProperty.propType,
        propAbbrevation: updateExistingProperty.propAbbrevation,
        propId: updateExistingProperty.propId,
        propBgColor: updateExistingProperty.propBgColor,
        propFgColor: updateExistingProperty.propFgColor,
    };
}

export function updateValues(value, listData, forExistingData) {
    // Parse the stringified array
    let parsedValue = Array.isArray(value) ? value : JSON.parse(value || "[]");
    let processListData = Array.isArray(listData) ? listData : JSON.parse(listData || "[]") 
    // Iterate over parsed values and update properties based on listData
    let updatedValue = parsedValue.map(item => {
        let matchingProp = processListData.find(prop => prop?.propId === item?.propId);
        let updateExistingProperty = processListData.find(prop => prop?.propName === item?.propName && prop.propAbbrevation === item.propAbbrevation && prop.propType === item.propType)
        if (matchingProp && !forExistingData) { 
            return updateItemFromMatchingProp(item, matchingProp);
        }
        if (forExistingData && updateExistingProperty) {
            return updateItemFromExistingProp(item, updateExistingProperty);
        }
        return null; // Mark for removal if no match is found
    })
    .filter(item => item !== null);
    
    return JSON.stringify(updatedValue); // Convert back to string
}
export async function processMultipleSheetTimeSeriesRowsForMDV(gridRef, columnDefinitions, setUndoStack, setRedoStack, oldColDefs, newColDefs, previousColDef) {
    const { loggedInUser } = xTablesStore.getState().gridReducer;
    const rows = gridRef.current.api.getModel().rootNode.allLeafChildren
    const allColumnDefinations = JSON.parse(JSON.stringify(columnDefinitions))
    const totalRemovedColumnDefinations = allColumnDefinations.filter((col) => {return col.headerName !== 'Total'})
    const newRows = [];
    const undoStackData = [];
    const redoStackData = [];
    const rowsBeforeColumnConversion = [];
    
    gridRef?.current?.api?.forEachNode((node) => {
        const row = JSON.parse(JSON.stringify(node.data));
        let rowUpdated = false;
        let rowToUpdate = JSON.parse(JSON.stringify(row)); // Deep copy for modifications
        let prevData = JSON.parse(JSON.stringify(row));

        for (const currentColDef of totalRemovedColumnDefinations) {
            const colToEdit = currentColDef.field.endsWith('_es') 
                ? currentColDef.field 
                : currentColDef.field + '_es';

            const originalValue = JSON.parse(JSON.stringify(row?.[colToEdit]?.value || ''));
            if (originalValue && originalValue !== '') {
                rowsBeforeColumnConversion.push(JSON.parse(JSON.stringify(row)));
            }

            if (row?.[colToEdit]?.value) {
                const newValue = updateValues(rowToUpdate?.[colToEdit]?.value, currentColDef.listData);
                let myUpdatedValueForRow = updateCellValue(prevData, colToEdit, "value", newValue, loggedInUser);
                
                rowToUpdate[colToEdit] = myUpdatedValueForRow;
                rowToUpdate[currentColDef.field] = rowToUpdate?.[colToEdit]?.value;
                
                undoStackData.push({
                    columnId: currentColDef.colId,
                    rowIndex: row['#'] - 1,
                    id: row.id,
                    originalValue: JSON.parse(JSON.stringify(row?.[colToEdit]?.value))
                });

                redoStackData.push({
                    columnId: currentColDef.colId,
                    rowIndex: rowToUpdate['#'] - 1,
                    id: rowToUpdate.id,
                    rowValue: JSON.parse(JSON.stringify(rowToUpdate?.[colToEdit]?.value))
                });

                rowUpdated = true;
            }
        }

        if (rowUpdated) {
            newRows.push(rowToUpdate);
        }
    });

    const stackData = {
        type: 'column',
        action: 'updateColumnProperties',
        rows,
        colDef: oldColDefs,
        previousColDef: previousColDef,
        editColumnIds: totalRemovedColumnDefinations.map(col => col.field), // List of edited columns
        isTimeSeriesUpdate: true,
        newColDefs,
        updatedColumnDefs: allColumnDefinations
    };

    // 🔹 Store **one undo entry** for all columns
    setUndoStack([
        {
            ...stackData,
            undoStackData,
            colTypes: totalRemovedColumnDefinations.map(col => col.type),
            redoStackData,
            cellRows: JSON.parse(JSON.stringify(newRows)),
            previousRows: JSON.parse(JSON.stringify(rowsBeforeColumnConversion))
        }
    ]);

    return newRows;
}

export async function processSheetRowsForMDV(gridRef, colToEdit, currentColDef, setUndoStack, setRedoStack, columns, prevListData) {
    const { loggedInUser } = xTablesStore.getState().gridReducer;
    const rows = gridRef.current.api.getModel().rootNode.allLeafChildren
    const newRows = [];
    const undoStackData = [];
    const redoStackData = [];
    const rowsBeforeColumnConversion = [];
    let rowsAfterColumnConversion = [];
    
    gridRef?.current?.api?.forEachNode((node) => {
        const isParent = node.childrenAfterGroup.length > 0;
        const isMDVParentWithRollup =
        currentColDef.type === 'multi dimensional value' &&
          checkIfRollupEnabledInMDV(currentColDef.listData) &&
          isParent; 
        const row = JSON.parse(JSON.stringify(node.data))
        const originalValue = JSON.parse(JSON.stringify(row?.[colToEdit]?.value || ''));
        if (originalValue && originalValue != '') {
            rowsBeforeColumnConversion.push(JSON.parse(JSON.stringify(row)))
        }
    
        if (row?.[colToEdit]?.value) {
            const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
            let rowToUpdate = deepCopy(row); // Shallow copy for modification
            let prevData = { 
                ...row, 
                [colToEdit]: { 
                    ...row[colToEdit], 
                    value: row[colToEdit]?.value
                } 
            };

            let newValue = updateValues(rowToUpdate?.[colToEdit]?.value, currentColDef.listData);
            let myUpdatedValueForRow = updateCellValue(prevData, colToEdit, "value", newValue, loggedInUser);
            rowToUpdate[colToEdit] = myUpdatedValueForRow
            rowToUpdate[currentColDef.field] = rowToUpdate?.[colToEdit]?.value
            newRows.push(rowToUpdate);
            undoStackData.push({
                rowIndex: row['#'] - 1,
                id: row.id,
                originalValue: JSON.parse(JSON.stringify(row?.[colToEdit]?.value))
            })
            redoStackData.push({
                rowIndex: rowToUpdate['#'] - 1,
                id: rowToUpdate.id,
                rowValue: JSON.parse(JSON.stringify(rowToUpdate?.[colToEdit]?.value))
            })
        }
    })

    rowsAfterColumnConversion = JSON.parse(JSON.stringify(newRows))

    const stackData = {
        type: 'column',
        action: 'updateColumnProperties',
        rows,
        columnId: currentColDef.colId,
        colDef: columns,
        editColumnId: colToEdit,
      };
  
      setUndoStack([{
        ...stackData,
        undoStackData,
        colType: currentColDef.type,
        redoStackData,
        cellRows: rowsAfterColumnConversion,
        previousRows: rowsBeforeColumnConversion
      }]);

    return newRows;
}

export async function processMdvRowsWithRollup(gridRef, colToEdit, currentColDef, setUndoStack, columns) {
    try {
        const { loggedInUser } = xTablesStore.getState().gridReducer;
        const rows = gridRef.current.api.getModel().rootNode.allLeafChildren
        let rowNodes = [];
        const undoStackData = [];
        const redoStackData = [];
        const rowsBeforeColumnConversion = [];
        let col = currentColDef.field;
        let processedRows = {};
        const listData = typeof currentColDef.listData === 'string' ? JSON.parse(currentColDef.listData) : currentColDef.listData;
        gridRef?.current?.api?.forEachNode((node) => {
            if (processedRows[node.data.id]) {
                return;
            }

            if (node.childrenAfterGroup.length > 0) {
                updateParentRecursively(node, col, listData, rowNodes, processedRows, loggedInUser, undoStackData, redoStackData, rowsBeforeColumnConversion);
            } else {
                processLeafNode(node, col, listData, rowNodes, processedRows, loggedInUser, undoStackData, redoStackData, rowsBeforeColumnConversion);
            }
        })

        const stackData = {
            type: 'column',
            action: 'updateColumnProperties',
            rows,
            columnId: currentColDef.colId,
            colDef: columns,
            editColumnId: colToEdit,
        };

        setUndoStack([{
            ...stackData,
            undoStackData,
            colType: currentColDef.type,
            redoStackData,
            cellRows: JSON.parse(JSON.stringify(rowNodes)),
            previousRows: rowsBeforeColumnConversion
        }]);


        return rowNodes;
    } catch (error) {
        console.error("Error in processMdvRowsWithRollup", error);

    }
}

const processLeafNode = (node, col, listData, rowNodes, processedRows, loggedInUser, undoStackData, redoStackData, rowsBeforeColumnConversion) => {
    try {
        if (!node.data || !(col in node.data) || !node.data[col]) return;
        processedRows[node.data.id] = node.data;
        const prevData = JSON.parse(JSON.stringify(node.data));
        if (prevData[col] && prevData[col] !== "") {
            rowsBeforeColumnConversion.push(JSON.parse(JSON.stringify(prevData)))
        }
        let rowData = parseRowData(node.data[col]);
        if (!rowData || (Array.isArray(rowData) && rowData.length === 0)) return;
        let updatedRowData = updateRowStructureAccordingToUpdatedOne(rowData, listData);

        updateMDVCell(node.data, col, updatedRowData, loggedInUser, rowNodes);

        undoStackData.push({
            rowIndex: prevData['#'] - 1,
            id: prevData.id,
            originalValue: JSON.parse(JSON.stringify(prevData?.[col + '_es']?.value))
        });

        redoStackData.push({
            rowIndex: node.data['#'] - 1,
            id: node.data.id,
            rowValue: JSON.parse(JSON.stringify(node.data?.[col + '_es']?.value))
        });

    } catch (error) {
        console.error("Error in processLeafNode dataharvestHelper", error)
    }
}

const updateMDVCell = (nodeData, col, updatedRowData, loggedInUser, rowNodes) => {
    try {
        nodeData[col] = JSON.stringify(updatedRowData);
        nodeData[col + '_es'] = updateCellValue(nodeData, col + '_es', "value", nodeData[col], loggedInUser);
        if (rowNodes) rowNodes.push(nodeData);
    } catch (error) {
        console.error("Error in updateCell dataharvestHelper ", error);

    }
}

const parseRowData = (rowData) => {
    if (typeof rowData === 'string') {
        try {
            let parsedValue = JSON.parse(rowData);
            return parsedValue
        } catch (e) {
            console.error("Error parsing rowData:", e);
            return null;
        }
    }
    return rowData;
};

const updateRowStructureAccordingToUpdatedOne = (rowData, listData) =>{
    try {
        const updatedRowData = rowData
            .map(row => {
                const matchingStructure = listData.find(list => list.propId === row.propId);

                if (!matchingStructure) {
                    return null;
                }

                const updatedRow = { ...row };

                // Update fields if different
                if (updatedRow.propName !== matchingStructure.propName) {
                    updatedRow.propName = matchingStructure.propName;
                }
                if (updatedRow.propType !== matchingStructure.propType) {
                    updatedRow.propType = matchingStructure.propType;
                    if (updatedRow.propValue) delete updatedRow.propValue
                }
                if (updatedRow.propAbbrevation !== matchingStructure.propAbbrevation) {
                    updatedRow.propAbbrevation = matchingStructure.propAbbrevation;
                }

                if ('rollup' in matchingStructure) {
                    if (updatedRow.rollup !== matchingStructure.rollup) {
                        updatedRow.rollup = matchingStructure.rollup;
                    }
                } else {
                    delete updatedRow.rollup;
                }

                if ('propBgColor' in matchingStructure) {
                    if (updatedRow.propBgColor) {
                        if (updatedRow.propBgColor !== matchingStructure.propBgColor) {
                            updatedRow.propBgColor = matchingStructure.propBgColor;
                        }
                    }else{
                        updatedRow["propBgColor"] = matchingStructure.propBgColor;
                    }
                }

                if ('propFgColor' in matchingStructure) {
                    if (updatedRow.propFgColor) {
                        if (updatedRow.propFgColor !== matchingStructure.propFgColor) {
                            updatedRow.propFgColor = matchingStructure.propFgColor;
                        }
                    }else{
                        updatedRow["propFgColor"] = matchingStructure.propFgColor;
                    }
                }

                return updatedRow;
            })
            .filter(row => row !== null);

        return updatedRowData;
    } catch (error) {
        console.error("Error in updateRowStructureAccordingToUpdatedOne",error);
    }
}

const updateParentRecursively = (
    node,
    col,
    listData,
    rowNodes,
    processedRows,
    loggedInUser,
    undoStackData,
    redoStackData,
    rowsBeforeColumnConversion
) => {
    try {
        if (!node || !node.childrenAfterGroup || node.childrenAfterGroup.length === 0) {
            return;
        }

        node.childrenAfterGroup.forEach(childNode => {
            if (childNode.childrenAfterGroup && childNode.childrenAfterGroup.length > 0) {
              // group child -> recursively compute its rollup first
              updateParentRecursively(
                childNode,
                col,
                listData,
                rowNodes,
                processedRows,
                loggedInUser,
                undoStackData,
                redoStackData,
                rowsBeforeColumnConversion
              );
            } else {
              // leaf child -> ensure it is processed so child.data[col] exists
              // processLeafNode signature assumed same as in your original code
              processLeafNode(
                childNode,
                col,
                listData,
                rowNodes,
                processedRows,
                loggedInUser,
                undoStackData,
                redoStackData,
                rowsBeforeColumnConversion
              );
            }
          });

        const rollupFields = returnRollUpFields(JSON.parse(JSON.stringify(listData)));
        const prevData = JSON.parse(JSON.stringify(node.data));

        if (prevData[col] && prevData[col] !== "") {
            rowsBeforeColumnConversion.push(JSON.parse(JSON.stringify(prevData)))
        }

        const childParsedListArray = [];
        node.childrenAfterGroup.forEach(child => {
          if (child.data && (col in child.data) && child.data[col]) {
            // child.data[col] may be a JSON string or already an array
            let parsed;
            try {
              parsed =
                typeof child.data[col] === "string"
                  ? JSON.parse(child.data[col])
                  : JSON.parse(JSON.stringify(child.data[col]));
            } catch (e) {
              // fallback: if parse fails, try to use as-is
              parsed = child.data[col];
            }
            if (parsed) childParsedListArray.push(parsed);
          }
        });
    
        // 4) Apply each child's rollup/values into the parent's rollupFields
        childParsedListArray.forEach(childParsedData => {
          // normalize against updated structure
          const updatedRowData = updateRowStructureAccordingToUpdatedOne(childParsedData, listData);
          const childRollUpFields = returnRollUpFields(JSON.parse(JSON.stringify(updatedRowData)));
          childRollUpFields.forEach(entity => {
            const objToUpdate = rollupFields.find(field => field.propId === entity.propId);
            updateMDVRollUpValueAddNewProp(objToUpdate, entity);
          });
        });
    

        checkIfAvgRollUpFieldExistsAndUpdate(rollupFields);

        node.data[col] = JSON.stringify(rollupFields);
        node.data[col + '_es'] = updateCellValue(node.data, col + '_es', "value", node.data[col], loggedInUser)

        if (rowNodes) rowNodes.push(node.data);
        processedRows[node.data.id] = node.data;

       try {
         undoStackData.push({
             rowIndex: prevData['#'] - 1,
             id: prevData.id,
             originalValue: JSON.parse(JSON.stringify(prevData?.[col + '_es']?.value))
         })
 
         redoStackData.push({
             rowIndex: node.data['#'] - 1,
             id: node.data.id,
             rowValue: JSON.parse(JSON.stringify(node.data?.[col + '_es']?.value))
         });
 
       } catch (error) {
        console.error("Error parsing in update ParentRecursively ", error);
        
       }
    } catch (error) {
        console.error("Error in updateParentRecursively", error);

    }
}

export const updateListDataHelper = async ({
    params,
    gridRef,
    setColumnDefs,
    updateColumnWithId,
    autoColumnGroupDefs,
    updateMultipleColumns,
    dispatch,
    setUndoStack,
    setRedoStack,
    columns,
    shouldModify
  }) => {
    const newColDefs = gridRef?.current?.props?.columnDefs;
    if (!newColDefs?.length || !params.column) return;
    const previousColDefs = deepCopy(sanitizeColumnDefs(gridRef?.current?.props?.columnDefs));
    for (const currentColDef of newColDefs) {
      if (params.column.colId === currentColDef.colId) {
        await handleSingleColumnUpdate({
          currentColDef,
          params,
          setColumnDefs,
          updateColumnWithId,
          autoColumnGroupDefs,
          gridRef,
          dispatch,
          setUndoStack,
          setRedoStack,
          columns,
          shouldModify
        });
      } else if (currentColDef.groupId && currentColDef.children && !currentColDef.block) {
        await handleGroupedColumns({
          children: currentColDef.children,
          params,
          setColumnDefs,
          updateColumnWithId,
          autoColumnGroupDefs,
          gridRef,
          dispatch,
          setUndoStack,
          setRedoStack,
          columns,
        });
      } else if (currentColDef.block && currentColDef.children) {
        const shouldUpdate = currentColDef?.children?.some(column =>
            column.children?.some(childColumn => childColumn.colId === params.column.colId)
        );
        if(shouldUpdate){
            await handleTimeSeriesBlockColumns({
                currentColDef,
                params,
                updateMultipleColumns,
                autoColumnGroupDefs,
                newColDefs,
                gridRef,
                dispatch,
                setUndoStack,
                setRedoStack,
                previousColDefs,
                shouldModify
              });
        }
      }
    }
  };
  
  const handleSingleColumnUpdate = async ({
    currentColDef,
    params,
    setColumnDefs,
    updateColumnWithId,
    autoColumnGroupDefs,
    gridRef,
    dispatch,
    setUndoStack,
    setRedoStack,
    columns,
    shouldModify
  }) => {
    if (currentColDef.shareable && currentColDef.sharedlistInfo) {
      const listObject = { ...currentColDef.sharedlistInfo, options: processListValues(params.colDef.listData) };
      await addSharedList(listObject);
    }
    
    const prevListData = currentColDef.listData;
    currentColDef.listData = params.colDef.listData;
    setColumnDefs({ colDefs: gridRef.current.props.columnDefs });
    updateColumnWithId(currentColDef, makeColumnArrayForDB(autoColumnGroupDefs, gridRef.current.props.columnDefs), true);
  
    if (shouldModify && currentColDef.type === "multi dimensional value") {
      await processAndApplyUpdates(gridRef, currentColDef, setUndoStack, setRedoStack, columns, prevListData, dispatch);
    }
  };
  
  const handleGroupedColumns = async ({
    children,
    params,
    setColumnDefs,
    updateColumnWithId,
    autoColumnGroupDefs,
    gridRef,
    dispatch,
    setUndoStack,
    setRedoStack,
    columns,
  }) => {
    for (const child of children) {
      if (params.column.colId === child.colId) {
        await handleSingleColumnUpdate({
          currentColDef: child,
          params,
          setColumnDefs,
          updateColumnWithId,
          autoColumnGroupDefs,
          gridRef,
          dispatch,
          setUndoStack,
          setRedoStack,
          columns,
        });
      }
    }
  };
  
  const handleTimeSeriesBlockColumns = async ({
    currentColDef,
    params,
    updateMultipleColumns,
    autoColumnGroupDefs,
    newColDefs,
    gridRef,
    dispatch,
    setUndoStack,
    setRedoStack,
    previousColDefs,
    shouldModify
  }) => {
    
    const oldColDefs = currentColDef.children.flatMap((column) => {
        const oldDefs = [];
    
        if (column.headerName === 'Total') {
            oldDefs.push({ ...column }); // Store a shallow copy of 'Total' column
        }
    
        if (column.children) {
            oldDefs.push(...JSON.parse(JSON.stringify(column.children))); // Deep copy child columns
        }
    
        return oldDefs;
    });

    const colDefsToUpdate = currentColDef.children.flatMap((column) => {
        const updatedColumns = [];

        if (column.headerName === 'Total') {
            column.listData = JSON.stringify(params.colDef.listData);
            updatedColumns.push(column);
        }
        // Update child columns if they exist
        updatedColumns.push(...(column.children || []).map(childColumn => {
            childColumn.listData = JSON.stringify(params.colDef.listData);
            return childColumn;
        }));

        return updatedColumns;
    });

    updateMultipleColumns(colDefsToUpdate, makeColumnArrayForDB(autoColumnGroupDefs, newColDefs));
  
    if (shouldModify) {
      const updatedRows = await processMultipleSheetTimeSeriesRowsForMDV(
        gridRef,
        colDefsToUpdate,
        setUndoStack,
        setRedoStack,
        oldColDefs,
        newColDefs,
        previousColDefs
      );
      dispatch(categorizeAndStoreUpdatedRows({ update: updatedRows },gridRef));
      gridRef?.current?.api?.applyTransaction({ update: updatedRows });
      setTimeout(() => {
        gridRef?.current?.api?.redrawRows();
      }, 100);
    }
  };
  
  const processAndApplyUpdates = async (gridRef, colDef, setUndoStack, setRedoStack, columns, prevListData, dispatch) => {
    const colToEdit = colDef.field.endsWith("_es") ? colDef.field : colDef.field + "_es";
    const updatedRows = checkIfRollupEnabledInMDV(colDef.listData) ? await processMdvRowsWithRollup(gridRef, colToEdit, colDef, setUndoStack, columns) : await processSheetRowsForMDV(gridRef, colToEdit, colDef, setUndoStack, setRedoStack, columns, prevListData);
    dispatch(categorizeAndStoreUpdatedRows({ update: updatedRows },gridRef));
    gridRef?.current?.api?.applyTransaction({ update: updatedRows });
    setTimeout(() => {
      gridRef?.current?.api?.redrawRows();
    }, 100);
  };
  
export const formatColumn = (payload) => {
    const {updateColumnWithId, columns, setColumnDefs, openMenuFnOptionsMenu, onCellValueChanged, gridRef, readOnlyMode, onClickOpenRightDrawer, onRowSelected, valueChangedByValueGetter,dispatch, currentSelectedSheet, userData, updateMultipleColumns, setUndoStack, setRedoStack,display, sheetLocked, highlightTScellOnFilter,isFilterOn} = payload
    const NumberRenderer = (params) => {
        return <CustomNumberRenderer params={params} />;
    };

    const updateListData = async (params, columns, shouldModify) => {await updateListDataHelper({params,gridRef, setColumnDefs, updateColumnWithId, autoColumnGroupDefs, updateMultipleColumns, dispatch, setUndoStack, setRedoStack, columns, shouldModify})} 

    const DropdownRendererWrapper = (params) => {
        let col = params.colDef.field + '_es';
        let isSelectionType = params.colDef.type.toLowerCase() === "person" || params.colDef.type.toLowerCase() === "assignee" ? "person" : params.colDef.type.toLowerCase() === "dropdown" ? "multiple" : "single";
        return <CustomDropdownRenderer params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
        }} isSelectionType={isSelectionType} updateListData={updateListData} readOnlyMode={readOnlyMode}/>;
    };
    
    const FushionColumnRenderer = (params) => {
        let col = params.colDef.field + '_es';
        let isSelectionType = params.colDef.type.toLowerCase() === "multi dimensional value";
        return <MultiDimensionalCustomColumn params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
        }} isSelectionType={isSelectionType} updateListData={updateListData} readOnlyMode={readOnlyMode} highlightTScellOnFilter={highlightTScellOnFilter}/>
      }

      const FushionEditorWrapper = (params) => {
        let col = params.colDef.field + '_es';
        let isSelectionType = params.colDef.type.toLowerCase() === "multi dimensional value";
        const editorClass = 'mdv-popup-editor';
        return <div className={`ag-popup-editor ${editorClass}`}><MultiDimensionalValueTypeEditor params={params} updateDB={(newValue, callBack) => {
            updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field
                , callBack})
        }} isSelectionType={isSelectionType} updateListData={updateListData} gridRef={gridRef}/></div>
      }
    const DateRendererWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomDateRenderer params={params} columnSubType={params.colDef.rollup} updateRowDHelper={(newValue) => updateRowD({params, newVal: newValue,data: params.node.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})} readOnlyMode={readOnlyMode } sheetType = {currentSelectedSheet.sheetType}  />;
    };

    const DropdownEditorWrapper = (params) => {
        let col = params.colDef.field + '_es';
        let isSelectionType = params.colDef.type.toLowerCase() === "dropdown" ? "multiple" : "single";
        return <CustomDropdownEditor params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
        }} isSelectionType={isSelectionType} updateListData={updateListData} />;
    };

    const StatusRollupEditorWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomDropdownEditor params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col,gridRef,onCellValueChanged, field: params.colDef.field})
        }} updateListData={updateListData}/>;
    };
    const StatusEditorWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomDropdownEditor params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col,gridRef,onCellValueChanged, field: params.colDef.field})
        }} updateListData={updateListData} readOnlyMode={readOnlyMode}/>;
    };
    const StatusRollupRendererWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomDropdownRenderer params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
        }} readOnlyMode={readOnlyMode}/>;
    };

    const StatusRendererWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomDropdownRenderer params={params} updateDB={(newValue) => {
            updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
        }} readOnlyMode={readOnlyMode} />;
    };

    const PredecessorRendererWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomPredecessorRenderer params={params} updateRowDHelper={(newValue) => updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field, rollup: params.colDef.rollup})} isOwner={(currentSelectedSheet?.user_email === userData?.email)} readOnlyMode={readOnlyMode} sheetType = {currentSelectedSheet.sheetType}/>;
    };

    const PredecessorEditorWrapper = (params) => {
        let col = params.colDef.field + '_es';
        return <CustomPredecessorEditor params={params} updateRowDHelper={(newValue) => updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field, rollup: params.colDef.rollup})} />;
    };
    
    
    const processColumnDef = (columnDef,coldefObj,colIdObj,childIndex) => { 
        let {activeFilters} = xTablesStore.getState().gridReducer 
        if (columnDef && columnDef.field !== 'Primary Column' && !coldefObj[columnDef.field || columnDef.colId || columnDef.cellRenderer]) {
            columnDef["comparator"] = columnDef.type === 'number' ? NumberComparator : columnDef.type === 'date' ? DateComparator : myComparator;
            columnDef["cellEditor"] = CustomCellEditor
            columnDef["filter"] = CustomTextNumberFilter
            columnDef["cellEditorPopup"] = true
            columnDef.width = columnDef.width || 200
            columnDef.editable = !readOnlyMode && !(currentSelectedSheet.sheetType==='filterSheet');
            columnDef.minWidth = 200
            columnDef.suppressMovable = readOnlyMode && true;
            columnDef.cellStyle = (params) => {
                let styles = {}
                if (params.data) {
                    let cellInfo = { ...params.data[params.colDef.field + "_es"] }
                    if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
                        styles = cellInfo.cellStyle 
                    }
                    let {color} = xTablesStore.getState().gridReducer
                    if(cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles={...styles,backgroundColor:color}
                    return styles
                }
                return styles
            }
            if (columnDef.cellEditorParams) {
                delete columnDef.cellEditorParams
            }
            if (columnDef.type && columnDef.type.toLowerCase() == 'date') {
                columnDef.cellRenderer = DateRendererWrapper
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.cellEditor = CustomDateCellEditor
                columnDef.cellEditorPopup = true;
                columnDef.cellDataType = 'dateString';
                columnDef.cellEditorParams = { min: '1600-01-01', max: '2200-01-01' }
                // // columnDef.cellDataType = 'dateString';
                // columnDef.cellEditorParams = { min: '01/01/1600', max: '01/01/2200' } date copy paste
                columnDef.filter = CustomDateFilter
                // if (columnDef.rollup !== 'None') {
                //     columnDef.valueGetter = (params) => {
                //         if (params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length && (params.colDef?.rollup === "Max" || params.colDef?.rollup === "Min")) {
                            
                //                 let newValue = getParentDateAsRollUp(params.node, params.colDef.field, params.colDef?.rollup)
                //                 if (params.node?.data && params.colDef.field in params.node.data) {
                //                     if (params?.node.data[params.colDef.field] != newValue) {
                //                         let isRollupValueChanged = true;
                //                         valueChangedByValueGetter(params.node, params.colDef.field, newValue, params,isRollupValueChanged );
                //                 }}
                //                 return newValue
                //             }
                        
                //         return params?.data[params.colDef.field];
                //     //     else if (params.data && params.colDef.field in params.data) {
                //     //         let doesRowHavePredecessorRow = params.data.predecessorNodes
                //     //         let doesRowIsParent=params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length>0        
                //     //         // if (doesRowIsParent && doesRowHavePredecessorRow && params.colDef.linkedColumns && params.colDef.linkedColumns.predecessor && params.colDef.linkedColumns.predecessorEndDate) {
                //     //         //     let {minValue, predecessorCellValue}=getMinValueFromPredecessor(params?.data[params.colDef.field],params?.data[params.colDef.linkedColumns.predecessor ],params.colDef.linkedColumns.predecessorEndDate,params, params.colDef.linkedColumns.predecessor)
                //     //         //     if(minValue!==params?.data[params.colDef.field])
                //     //         //     console.log("minvalue",minValue,'actual value',params?.data[params.colDef.field], predecessorCellValue,"valuechangebyvaluegettter")
                //     //         //      valueChangedByValueGetter(params.node, params.colDef.field,minValue, params,predecessorCellValue );
                //     //         //      return params?.data[params.colDef.field];
                //     //         // }                                                     
                //     //         return params?.data[params.colDef.field];
                //     //     }
                //     // }
                // } }
            //    columnDef.valueSetter = (params) => dateValueSetter(params, valueChangedByValueGetter)
             columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
        }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'dropdown') {
                columnDef.cellRenderer = DropdownRendererWrapper
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.cellDataType = false;
                columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                columnDef.cellEditor = DropdownEditorWrapper
                columnDef.cellEditorPopup = true
                columnDef.filter = CustomDropdownFilter
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'dropdownsingle') {
                columnDef.cellRenderer = DropdownRendererWrapper
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                columnDef.cellDataType = false;
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                columnDef.cellEditor = DropdownEditorWrapper
                columnDef.cellEditorPopup = true
                columnDef.filter = CustomDropdownFilter
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'shareablerolluplist') {
                let lastSynced = new Date(columnDef?.lastSyncedTimestamp);
                const lastUpdated = new Date(columnDef?.sharedlistInfo?.last_updated);
                const { columnSyncTimestamps,statusColumns} = xTablesStore.getState().gridReducer;
                if (!statusColumns?.[columnDef.columnElasticid]&& !columnDef.azureColumn) {
                    dispatch({ type: XTABLES_ACTION_TYPES.SET_STATUS_COLS, payload: {colId: columnDef.columnElasticid, statusColumns: columnDef} })
                }
                if (!columnSyncTimestamps?.[columnDef.columnElasticid]&& !columnDef.azureColumn) {
                    if (columnDef?.lastSyncedTimestamp) {
                        dispatch({
                            type: XTABLES_ACTION_TYPES.SET_LAST_SYNCED_TIMESTAMP,
                            payload: {
                                colId: columnDef.columnElasticid,
                                timestamp: columnDef?.lastSyncedTimestamp
                            }
                        })
                    }
                } else {
                    lastSynced = new Date(columnSyncTimestamps?.[columnDef.columnElasticid]);
                }
                if (((!columnDef?.lastSyncedTimestamp && !columnSyncTimestamps?.[columnDef.columnElasticid] )|| lastSynced < lastUpdated) && display !== "card" && display !== "summary" && !sheetLocked && !columnDef.azureColumn&& currentSelectedSheet?.sheetType !== 'filterSheet'&&!isFilterOn) {
                    setTimeout(() => {
                        renderAlert(
                            <> The associated status sheet has changed for column{' '}
                                    <strong>{columnDef?.headerName}</strong>. Please <strong>recalculate</strong> to update status values. <br />
                                    <strong>How to Recalculate:</strong><br />
                                    Right-click on the <strong>Status</strong> column → Open context menu → Select <strong>"Recalculate"</strong>. 
                            </>,
                            "info", 10000
                        );
                      }, 5000);
                  }
                  
                const { listData, precedenceMapping } = columnDef.listData === undefined ||(Array.isArray(columnDef.listData) && columnDef.listData.every(item => typeof item === 'string'))
                ? { listData: columnDef.listData, precedenceMapping: null }
                : generateListDataForRollupStatus(JSON.parse(columnDef.listData));    
                dispatch({type:XTABLES_ACTION_TYPES.SET_STATUSCOLUMN_STATE,statusColumnRollupInfo:{listData,precedenceMapping}})
                columnDef.cellRenderer = StatusRollupRendererWrapper
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef["listData"] = columnDef["listData"]?columnDef["listData"]:columnDef['sharedlistIdlistData']
                columnDef.cellDataType = false;
                columnDef.cellEditor = StatusRollupEditorWrapper
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                if (columnDef.listData === undefined ||(Array.isArray(columnDef.listData) && columnDef.listData.every(item => typeof item === 'string'))) {
                        columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef) 
                    }
                else{
                    columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                }
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'status') {
                let array = ['To Do', 'In Progress', 'Reopened', 'Done', 'Closed', 'Duplicate','Released To QA','QA Complete']
                columnDef.cellRenderer = StatusRendererWrapper
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef["listData"] = array
                columnDef.cellDataType = false;
                columnDef.cellEditor = StatusEditorWrapper
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                    // if (columnDef.status) {
                    //     columnDef.valueGetter = (params) => {
                    //         if (params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length) return getParentValueAsStatus(params.node, columnDef.field)
                    //         return params.data[columnDef.field];
                    //     }
                    //     columnDef.editable= (params) =>  makeParentCellNotEditable(params, columnDef)
                    // }
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'number') {
                columnDef.cellRenderer = NumberRenderer
                columnDef.cellRendererParams = { onClickOpenRightDrawer }
                columnDef.cellEditor = 'agNumberCellEditor';
                columnDef.cellDataType = 'number';
                delete columnDef.cellEditorPopup
                if (columnDef.cellEditorParams) { delete columnDef.cellEditorParams }
                columnDef.cellEditorParams = { preventStepping: true }
                if (columnDef.rollup !== "None") {
                    // columnDef.valueGetter = (params) => {
                    //     // if (params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length && (params.colDef?.rollup === "Max")) return getParentValueAsRollUp(params.node, params.colDef.field, params.colDef?.rollup)
                    //     // else
                    //     if (params.data && params.colDef.field in params.data) return params?.data[params.colDef.field];
                    // } 
                }
                columnDef.editable = columnDef.editable === false ? false : (params) => makeParentCellNotEditable(params, columnDef)
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'estimatedTime') {
                columnDef.cellEditorPopup = true;
                columnDef.cellRenderer = CustomCellRenderer
                columnDef.cellRendererParams = { onClickOpenRightDrawer }
                // columnDef.preventTypeChange = true;
                columnDef.editable = columnDef.editable === false ? false : (params) => makeParentCellNotEditable(params, columnDef)
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'duration') {
                columnDef.cellEditorPopup = true;
                columnDef.cellRenderer = CustomCellRenderer
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                // columnDef.valueGetter = (params) => {
                //     if (params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length >= 1) {
                //         let newValue = calculateDuration(params.data, params.colDef.field, params.colDef.linkedColumns?.startDate, params.colDef.linkedColumns?.endDate)
                //         if (params.node?.data && params.colDef.field in params.node.data) {
                //             if (params?.node.data[params.colDef.field] != newValue) valueChangedByValueGetter(params.node, params.colDef.field, newValue, params);
                //         }
                //         return newValue
                //     }
                //     else if (params.data && params.colDef.field in params.data) return params?.data[params.colDef.field];
                // }
                //columnDef.suppressFillHandle = true
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == "predecessor") {
                //columnDef.cellEditor=CustomCellEditor;
                columnDef.cellEditorPopup = true;
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                delete columnDef.predecessor
                columnDef.cellRenderer = PredecessorRendererWrapper;
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.cellEditor = PredecessorEditorWrapper
                // columnDef.valueGetter = (params) => {
                //         return correctPredecessorValue(params, params.data, params.colDef.field)
                // }
                columnDef.valueSetter = (params) => {
                    if (params.node && params.node?.data && params.colDef.type == "predecessor") {
                        {
                            if(params.newValue === null){
                                updateCellValue(params.node.data, columnDef.field + '_es', "value", '', userData.email)
                            }
                            let newVal = updatedPredecessorCellValue(params, params.data, params.colDef.field)
                            let dataField = params.colDef.field;
                            // Update the data field with the new value
                            let dataUpdated = params.node.data[dataField] !== newVal;
                            if (dataUpdated) {
                                params.node.data[dataField] = newVal;
                                if (params.node.data[dataField + '_es'] && params.node.data[dataField + '_es']?.value) params.node.data[dataField + '_es'].value = newVal;
                            }
                            // Return true if the data was updated
                            return dataUpdated;
                        }
                    }
                    return false;
                }
                columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                columnDef.suppressFillHandle = true
                handleLinkedColumns(columnDef, columns, updateColumnWithId);
                dispatch({ type: XTABLES_ACTION_TYPES.SET_PREDECESSORCOLUMN_STATE, predecessorcolumn: columnDef })
            }
            else if (columnDef.type && columnDef.type.toLowerCase() == 'multi dimensional value') {
                columnDef.cellRenderer = FushionColumnRenderer
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                columnDef.cellDataType = false;
                columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                columnDef.valueSetter = ((params) => {
                    if (params.node && params.node?.data && params.colDef.type == "multi dimensional value" && !params.context.applyClick) {
                        let dataField = params.colDef.field;
                        let newVal = params.newValue
                        params.node.data[dataField] = newVal;
                        params.newValue = newVal;
                        if (params.node.data[dataField + '_es'] && params.node.data[dataField + '_es']?.value) params.node.data[dataField + '_es'].value = newVal;
                        return true
                    }else{
                        params.context.applyClick = false;
                        return false;
                    }
                })
                columnDef.cellEditor=FushionEditorWrapper
                columnDef.cellEditorPopup=true
                if (columnDef.parent && columnDef.block) {
                    SetTimeSeriesColumnProperties(columnDef,valueChangedByValueGetter,childIndex);

                    if (columnDef.headerName === 'Total') {
                        columnDef.suppressFillHandle = true
                        SetTotalTimeSeriesColumnProperties(columnDef, coldefObj);
                    }
                }
            }
            else if ((columnDef.type && columnDef.type.toLowerCase() === 'person') || (columnDef.type && columnDef.type.toLowerCase() === 'assignee')) {
                columnDef.cellRenderer = DropdownRendererWrapper
                columnDef.cellRendererParams = { onClickOpenRightDrawer }
                columnDef.cellDataType = false;
                columnDef.editable= columnDef.editable === false ? false :  (params) =>  makeParentCellNotEditable(params, columnDef)
                if (columnDef.cellEditorParams) {
                    delete columnDef.cellEditorParams
                }
                columnDef.cellEditor = DropdownEditorWrapper
                columnDef.cellEditorPopup = true
                //columnDef.listData=  JSON.stringify(columnDef.listData);
            } 
            else if (!columnDef.cellRenderer) {
                columnDef.cellRenderer = CustomCellRenderer
                columnDef.cellRendererParams = {onClickOpenRightDrawer}
                if (!columnDef.cellEditor) {
                    columnDef.cellEditor = CustomCellEditor
                    columnDef.cellEditorPopup = true
                }
               // columnDef.filter = CustomTextNumberFilter
            }
            if (columnDef.field == '#') {
                columnDef.rowDrag = (params)=>{
                  if (readOnlyMode || params?.node?.data?.checkinagent||params?.node?.data?.isAzureRow||currentSelectedSheet.sheetType==='filterSheet')
                  return false
                else return true} 
                // columnDef.headerComponent = IndicatorCustomHeader
                if (columnDef.type === 'path') {
                    columnDef.width = 125
                    columnDef.minWidth = 125
                }
                else {
                    columnDef.width = 100
                    columnDef.minWidth = 100
                }
                // columnDef.maxWidth=130
                columnDef.filter = false
                columnDef.pinned = "left"
                columnDef.editable = false
                columnDef.suppressMovable = true
                columnDef.lockPosition = true
                columnDef.valueGetter = ({ node }) => {
                    if (columnDef.type === 'path') {
                        if (node.parent.id === 'ROOT_NODE_ID') return node.childIndex + 1
                        else {
                            return findtheFirstParentOfNode(node)
                        }
                    }
                    
                    else return node.sourceRowIndex + 1
                }
                columnDef.suppressMenu = false
                columnDef.resizable = false
                columnDef.cellRenderer = IndicatorRenderer
                columnDef.cellRendererParams = {
                    readOnlyMode, openMenuFnOptionsMenu, onClickOpenRightDrawer, onRowSelected
                }
                columnDef.headerName = '#'
            }
            columnDef.suppressDragLeaveHidesColumns = true
            
            if (columnDef.field == '#') {
                columnDef.cellStyle = { background: 'transparent', paddingLeft: 0 }
            }
            colIdObj[columnDef.field + "_es"] = columnDef
            if (sortObj[columnDef.colId]) columnDef.sort = sortObj[columnDef.colId]
            delete columnDef.minWidth
            delete columnDef.flex
            columnDef.enablePivot = false
            columnDef.sortable = false
            
            columnDef.editable = readOnlyMode ? false : columnDef.editable
            columnDef.deleteable = readOnlyMode ? false : columnDef.deleteable == false ? false : true


            coldefObj[columnDef.field || columnDef.colId || columnDef.cellRenderer ] = columnDef
            if (columnDef.children && columnDef.children.length > 0) {
                columnDef.children = columnDef.children.map((child,index) => processColumnDef(child,coldefObj,colIdObj,index)).filter(child=>child);
            }
            else if(!columnDef.field && !columnDef.children ) return undefined
            return columnDef;
        }
    };

    let defaultEmptyColumnCount = 10;
    let autoColumnGroupDefs = {};
    let sortObj = {};
    if (columns && columns.length) {
        let columnDefsNoComparator = sanitizeColumnDefs(columns);
        if (typeof columnDefsNoComparator == "string") columnDefsNoComparator = getParsedJSONObject(columnDefsNoComparator);
        else { 
              columnDefsNoComparator.forEach(col => {
            if (col.marryChildren === true && col.headerGroupComponentParams) {
                delete col.headerGroupComponentParams;
            }
            if(col.headerComponentParams) delete col.headerComponentParams;
        });
            columnDefsNoComparator = getParsedJSONObject(JSON.stringify(columnDefsNoComparator));}

        const autoColumnGroupIndex = columnDefsNoComparator && columnDefsNoComparator.length && columnDefsNoComparator.findIndex((column) => column.colId === 'ag-Grid-AutoColumn');

        if (autoColumnGroupIndex !== -1) {
            autoColumnGroupDefs = columnDefsNoComparator.splice(autoColumnGroupIndex, 1)[0];
            autoColumnGroupDefs = { ...autoColumnGroupDefs,  };
        }
        if (sortObj['ag-Grid-AutoColumn']) {
            autoColumnGroupDefs['sort'] = sortObj['ag-Grid-AutoColumn'];
        }
        let columnDefsWithComparator = [];
        if (!Array.isArray(columnDefsNoComparator)) columnDefsNoComparator = columnDefsNoComparator.colDefs;
        let coldefObj = {};
        let colIdObj = {};
        columnDefsNoComparator?.forEach((columnDef, index) => {
            if(!coldefObj[columnDef?.colId]){
                let processedColumn=processColumnDef(columnDef,coldefObj,colIdObj)
                if(processedColumn) columnDefsWithComparator.push(processedColumn);
            }  
        });
        delete autoColumnGroupDefs.minWidth;
        delete autoColumnGroupDefs.flex;
        delete autoColumnGroupDefs.pinned;
        autoColumnGroupDefs.sortable = false;
        autoColumnGroupDefs.enablePivot = false;
        const originalEditable =
        typeof autoColumnGroupDefs.editable === 'function'
          ? autoColumnGroupDefs.editable
          : () => !!autoColumnGroupDefs.editable;
        autoColumnGroupDefs.editable = (params) => {
            const { activeFilters, isFilterOrSummaryViewActive } =
              xTablesStore.getState().gridReducer;
          
            let reason = '';
          
            if (params?.data?.checkinagent || params?.data?.isAzureRow) {
              reason = 'HRMS / Azure row';
            } else if (
              (activeFilters && activeFilters.length > 0) ||
              isFilterOrSummaryViewActive
            ) {
              reason = 'Filters / Summary view active';
            } else if (readOnlyMode) {
              reason = 'Read-only mode';
            }
          
            if (reason) {
              console.warn('✋ Auto column edit blocked', {
                rowIndex: params.node?.rowIndex,
                colId: params.column?.getColId(),
                reason
              });
              return false;
            }
          
            // 🔑 delegate to original editable
            const result = originalEditable(params);
          
            if (typeof result !== 'boolean') {
              console.error('❌ editable() must return boolean', result);
              return false;
            }
          
            return result;
          };
            //autoColumnGroupDefs.editable = readOnlyMode ? false : autoColumnGroupDefs.editable;
        // autoColumnGroupDefs.wrapText = true;
        autoColumnGroupDefs.autoHeight = true;
        colIdObj[autoColumnGroupDefs.field + "_es"] = autoColumnGroupDefs;
        autoColumnGroupDefs.suppressDoubleClickExpand= true,
        autoColumnGroupDefs.cellClass = (params) => {
            if (params.data) {
                let classes = ["global-style", getIndentClass(params)];
                if (params.data[params.colDef.field + "_es"]) {
                    classes.push(params.data[params.colDef.field + "_es"].format)
                     if(display=='summary')(
                        classes.push('primary-summary')
                    )
                    return classes
                } else return classes;
            } else return ["global-style", getIndentClass(params)];
        };
        autoColumnGroupDefs.cellStyle = (params) => {
            let styles = {}
            if (params.data) {
                let cellInfo = { ...params.data[params.colDef.field + "_es"] }
                if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
                    styles = cellInfo.cellStyle 
                }
                let {color} = xTablesStore.getState().gridReducer
                if(cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles={...styles,backgroundColor:color}
                return styles
            }
            return styles
        };
        setColumnDefs({ colDefs: columnDefsWithComparator, autoColumnGroupDefs: autoColumnGroupDefs, colIdObj: colIdObj });
        return { colDefs: columnDefsWithComparator, autoColumnGroupDefs: autoColumnGroupDefs, colIdObj: colIdObj };
    } else {
        initializeDefaultColumns(readOnlyMode,defaultEmptyColumnCount,setColumnDefs);
};
}

function initializeDefaultColumns(readOnlyMode,defaultEmptyColumnCount,setColumnDefs) {
    let defaultAutoColumn = {
        headerName: 'Primary Column',
        field: 'Primary Column',
        minWidth: 200,
        colId: 'ag-Grid-AutoColumn',
        suppressMovable: true,
        editable: !readOnlyMode,
        lockPosition: true,
        cellRendererParams: { suppressCount: true },
    };
    let defaultColumnDefs = [];
    let emptyColumnArray = [];
    for (let i = 0; i < defaultEmptyColumnCount; i++) {
        emptyColumnArray.push({
            headerName: "Column" + i,
            field: "Column" + i,
            minWidth: 200,
            editable: !readOnlyMode ,
            deleteable: true,
            cellEditor: CustomCellEditor,
            cellEditorPopup: true,
        });
    }
    defaultColumnDefs = defaultColumnDefs.concat(emptyColumnArray);
    setColumnDefs({ colDefs: defaultColumnDefs, autoColumnGroupDefs: defaultAutoColumn, colIdObj: {} });
    return { colDefs: defaultColumnDefs, autoColumnGroupDefs: defaultAutoColumn, colIdObj: {} };
}

function generateDateStringsFromBlock(blockJson) {
    let block;
    try {
      block = typeof blockJson === 'string' ? JSON.parse(blockJson) : blockJson;
    } catch (e) {
      console.warn('Invalid block JSON:', blockJson);
      return [];
    }
  
    const { startDate, endDate, frequency } = block;
    if (block.type !== 'timeseries' || !startDate || !endDate || frequency !== 'day') return [];
  
    const result = [];
    let current = new Date(startDate);
    const end = new Date(endDate);
  
    if (isNaN(current) || isNaN(end)) return [];
  
    // Normalize both to local midnight
    current = new Date(current.getFullYear(), current.getMonth(), current.getDate());
    const normalizedEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  
    while (current <= normalizedEnd) {
      const mm = String(current.getMonth() + 1).padStart(2, '0');
      const dd = String(current.getDate()).padStart(2, '0');
      const yyyy = current.getFullYear();
      result.push(`${mm}-${dd}-${yyyy}`);
  
      // Move to next day
      current.setDate(current.getDate() + 1);
    }
  
    return result;
  }
  
const checkForTimeSeries = (block) => {
    if(!block) return false
    if (typeof block === 'string') {
        block = JSON.parse(block);
    }
    return ["startDate", "endDate", "frequency"].every((key) =>
        Object.prototype.hasOwnProperty.call(block, key)
    );
}
function findTimeSeriesColDetails (allColumnDefs) {
    const timeSeriesBlockColumn = allColumnDefs.find(obj => {
        if (!obj?.block) return false;
        if (!(obj.parent || obj.children )) return false;
    
        try {
          const block = JSON.parse(obj.block);
          return block.type === 'timeseries' || checkForTimeSeries(block);
        } catch (e) {
          console.warn('Invalid JSON in block:', obj.block);
          return false;
        }
      });

    return timeSeriesBlockColumn;
}


function isColKeyValidTimeSeriesDate(colKey, timeSeriesBlockColumn) {
    // 1. Check if colKey is a valid DD-MM-YYYY date
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;
    if (!datePattern.test(colKey)) return false;
  
    const [month, day, year] = colKey.split('-').map(Number);
    const colDate = new Date(year, month - 1, day);
    if (isNaN(colDate)) return false;
  
    if (!timeSeriesBlockColumn) return false;
  
    // 3. Parse block JSON and check date range
    try {
        const block = JSON.parse(timeSeriesBlockColumn.block);
        const startDate = new Date(block.startDate);
        const endDate = new Date(block.endDate);

        if (isNaN(startDate) || isNaN(endDate)) return false;
        const normStart = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const normEnd = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        return colDate >= normStart && colDate <= normEnd;
    } catch (e) {
      console.warn("Could not parse block JSON:", timeSeriesBlockColumn.block);
      return false;
    }
  }
  
  function isATimeSeriesCol(str) {
    const hyphenCount = (str.match(/-/g) || []).length;
    return hyphenCount === 2;
  }

  function findDurationCol(arr) {
    for (const obj of arr) {
      if (
        obj.linkedColumns &&
        typeof obj.linkedColumns === "object" &&
        "startDate" in obj.linkedColumns &&
        "endDate" in obj.linkedColumns
      ) {
        return obj;
      }
  
      if (Array.isArray(obj.children) && obj.children.length > 0) {
        const found = findDurationCol(obj.children);
        if (found) return found;
      }
    }
  
    return null; 
  }

  function isStatusCol(arr, field) {
    const found = arr.find(obj => obj.field === field);
  return found?.type === "shareableRollupList";
  }

  function countWeekdays(startDateStr, endDateStr) {
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);
  
    if (end < start) return '0d';
  
    let count = 0;
    let current = new Date(start);
  
    while (current <= end) {
        const day = current.getDay(); // 0 = Sunday, 6 = Saturday
        if (day !== 0 && day !== 6) {
            count++;
        }
        current.setDate(current.getDate() + 1);
    }
  
    return `${count}d`;
  }

  function removeMergedChanges(checkInAgentData, mergedUpdates) {
    if (!Array.isArray(checkInAgentData)) return [];
  
    // Build a map of updated rowId -> set of updated columns
    const updatesMap = new Map();
    for (const updatedRow of mergedUpdates) {
      if (!updatesMap.has(updatedRow.rowId)) {
        updatesMap.set(updatedRow.rowId, new Set());
      }
      for (const updatedCol of updatedRow.value) {
        updatesMap.get(updatedRow.rowId).add(updatedCol.column);
      }
    }
  
    // Filter out updated columns from the original data
    const filteredData = checkInAgentData
      .map(row => {
        if (!updatesMap.has(row.rowId)) {
          return row; // untouched row
        }
  
        const updatedColumns = updatesMap.get(row.rowId);
        const remainingCols = row.value.filter(col => !updatedColumns.has(col.column));
  
        // Keep row only if it still has columns left
        return remainingCols.length > 0
          ? { rowId: row.rowId, value: remainingCols }
          : null;
      })
      .filter(row => row !== null);
  
    return filteredData;
  }

  function addHoursMinutes(val1, val2) {
    const [h1, m1] = val1 === 0
        ? [0, 0]
        : val1.toString().split('.').map(Number);
    const [h2, m2] = val2 === 0
        ? [0, 0]
        : val2.toString().split('.').map(Number);

    let hours = (h1 || 0) + (h2 || 0);
    let minutes = (m1 || 0) + (m2 || 0);

    if (minutes >= 60) {
        hours += Math.floor(minutes / 60);
        minutes = minutes % 60;
    }

    // Return as string so minutes stay padded
    if(hours === 0 && minutes === 0) return '';
    return minutes >= 10
        ? `${hours}.${minutes}`      // keep both digits if >= 10
        : `${hours}.${minutes}`.replace('.0', '.'); // drop leading zero
}
 

export const mergeCheckInAgentData = async (
    gridRef,
    currentSelectedSheet,
    setischeckInAgentRowsToBeMerged,
    saveRowsViaUserActivity,
    dispatch
) => {
    try {
        let checkInAgentData = currentSelectedSheet.checkInAgentData;
        const updatedNodes = new Map();
        const allColumnDefs = gridRef.current.api.getColumnDefs();
        const api = gridRef.current.api;
        const timeSeriesBlockColumn = findTimeSeriesColDetails(allColumnDefs);
        let timeSeriesDatesArray = generateDateStringsFromBlock(JSON.parse(timeSeriesBlockColumn.block));
        const durationColumn = findDurationCol(allColumnDefs);
        const startDateColumnField = durationColumn.linkedColumns.startDate;
        const endDateColumnField = durationColumn.linkedColumns.endDate;
        const statusCol = allColumnDefs.find((col) => col.type === 'shareableRollupList');
        let updatedByUser = '';
        checkInAgentData.forEach(change => {
            const node = api.getRowNode(change.rowId);
            if (!node) return;

            const changedCols = [];

            change.value.forEach(colUpdate => {
                const { column, value } = colUpdate;
                let colToEdit = column.endsWith('_es') ? column : column + '_es'

                if (!node.data) node.data = {};
                node.data[colToEdit] = updateCellValue(node.data, column, "value", value.value, value.updatedBy);
                node.data[column] = typeof value.value === 'string' ? value.value : JSON.stringify(value.value);

                if (!updatedByUser) updatedByUser = value.updatedBy;
                changedCols.push(column);
            });

            if (!updatedNodes.has(node)) {
                updatedNodes.set(node, new Set());
            }
            changedCols.forEach(col => updatedNodes.get(node).add(col));

            // Walk up and schedule parents for rollup
            let parent = node.parent;
            while (parent) {
                if (!updatedNodes.has(parent)) {
                    updatedNodes.set(parent, new Set());
                }
                changedCols.forEach(col => updatedNodes.get(parent).add(col));
                parent = parent.parent;
            }
        });

        const filteredUpdatedNodes = new Map(
            Array.from(updatedNodes.entries()).filter(([node]) => node.id !== 'ROOT_NODE_ID')
        );

        let isTimeSeriesValuesChanged = false;
        // parent rollup logic
        filteredUpdatedNodes.forEach((changedCols, node) => {
            if (!node.childrenAfterGroup?.length) return;

            changedCols.forEach(colKey => {
                if (colKey === 'primaryCol') return;

                // rollup for timeseries
                if (isATimeSeriesCol(colKey)) {
                    const isValidTimeseriesColumn = isColKeyValidTimeSeriesDate(colKey, timeSeriesBlockColumn);

                    if (isValidTimeseriesColumn) {
                        const colKey_es = colKey + '_es';
                        let aggregated = (node.data && node.data[colKey]) ? JSON.parse(node.data[colKey]) : [];

                        if (aggregated.length > 0) {
                            aggregated = aggregated.map(metric => ({
                                ...metric,
                                propValue: "",
                            }));
                        }


                        node.childrenAfterGroup.forEach(child => {
                            const value = child.data[colKey];
                            if (!value) return;

                            let metrics;
                            try {
                                metrics = typeof value === 'string' ? JSON.parse(value) : value;
                            } catch {
                                return;
                            }

                            if (!Array.isArray(metrics)) return;

                            if (!aggregated || aggregated.length === 0) {
                                // Clone and clear all values
                                aggregated = metrics.map(metric => ({
                                    ...metric,
                                    propValue: "",
                                }));
                            }

                            metrics.forEach(metric => {

                                if (metric.propType !== 'number') return;
                                const abbr = metric.propAbbrevation;
                                if (abbr !== 'PT' && abbr !== 'AT') return;
                                const aggItem = aggregated.find(item => item.propAbbrevation === abbr);
                                if (!aggItem) return;

                                const current = aggItem.propValue || 0;
                                const addition = metric.propValue || 0;
                                aggItem.propValue = addHoursMinutes(current, addition).toString();
                            });
                        });

                        if (aggregated && aggregated.length > 0) {
                            if (!node.data) node.data = {};
                            node.data[colKey] = JSON.stringify(aggregated);
                            node.data[colKey_es] = updateCellValue(node.data, colKey, 'value', aggregated, updatedByUser);
                            isTimeSeriesValuesChanged =true
                        }
                    }

                }

                //rollup for status col 
                if(isStatusCol(allColumnDefs, colKey)){
                    const colKey_es = colKey + '_es';
                    let emptyChildrenValue = false;
                    let statuses = [];

                    node.childrenAfterGroup.forEach(child => {
                        const value = child.data[colKey];
                        if (value) {
                            if (value !== "" && value !== null && value !== undefined) {
                              processAndPush(value, statuses);
                            } else if (value !== "" && value !== null && value !== undefined && (
                              (typeof value === "string" && value.startsWith("{") &&
                                statusCol.listData.some(item => item.rowId === JSON.parse(value)?.rowId)) ||
                              statusCol.listData.some(item => item.value === value)
                            )) {
                              processAndPush(value, statuses);
                            }
                            else if (value === "" || value === null || value === undefined) emptyChildrenValue = true
                          }else{
                            emptyChildrenValue = true
                          }
                    });

                    const { listData, precedenceMapping } = generateListDataForRollupStatus(JSON.parse(statusCol.listData));

                    const parentStatus = emptyChildrenValue ? "" : determineParentRollupStatus(statuses, precedenceMapping, listData);

                    if(parentStatus !== ""){
                        if (!node.data) node.data = {};
                            node.data[colKey] = parentStatus;
                            node.data[colKey_es] = updateCellValue(node.data, colKey, 'value', parentStatus, updatedByUser);
                    }

                }
                let changedCol = allColumnDefs.find((col) => col.field === colKey);
                // rollup for startdate/enddate
                if (changedCol) {                
                    const colKey_es = colKey + '_es';
                    let dateStrings = [];
                    let updateDate = "";
                    node.childrenAfterGroup.forEach(child => {
                        const value = child.data[colKey];
                        if (!value) return;
                        dateStrings.push(value)

                    });

                    if (changedCol.rollup == 'Min') updateDate = findDate(dateStrings, "minDate")
                    else if (changedCol.rollup == 'Max') updateDate = findDate(dateStrings, "maxDate")

                    if(updateDate !== ""){
                        if (!node.data) node.data = {};
                            node.data[colKey] = updateDate;
                            node.data[colKey_es] = updateCellValue(node.data, colKey, 'value', updateDate, updatedByUser);
                    }
                }
            }

            );
        });

        
        const totalColDef = timeSeriesBlockColumn.children.find(col => col.headerName === "Total");
        const totalColKey = totalColDef.field;
        let totalMetricsTemplate;
        try {
            totalMetricsTemplate = typeof totalColDef.listData === 'string' ? JSON.parse(totalColDef.listData) : totalColDef.listData;
        } catch (e) {
            console.error("Invalid listData in Total column definition:", e);
            return;
        }

        // update total col and duration column 
        filteredUpdatedNodes.forEach((_, node) => {
            if (!node.data) return;

            let totalPT = 0;
            let totalAT = 0;

            timeSeriesDatesArray.forEach(colKey => {
                const value = node.data[colKey];
                if (!value) return;

                let metrics;
                try {
                    metrics = typeof value === 'string' ? JSON.parse(value) : value;
                } catch {
                    return;
                }

                if (!Array.isArray(metrics)) return;

                metrics.forEach(metric => {
                    if (metric.propType !== 'number') return;
            
                    const abbrev = metric.propAbbrevation;
                    const numericValue = metric.propValue || 0;
            
                    if (abbrev === 'PT') {
                        totalPT = addHoursMinutes(totalPT, numericValue);
                    } else if (abbrev === 'AT') {
                        totalAT = addHoursMinutes(totalAT, numericValue);
                    }
                });
            });

            const totalMetrics = totalMetricsTemplate.map(metric => {
                let value = "";
                if (metric.propAbbrevation === 'PT') {
                    value = totalPT.toString();
                } else if (metric.propAbbrevation === 'AT') {
                    value = totalAT.toString();
                }

                return {
                    ...metric,
                    propValue: value
                };
            });

            // Step 4: Assign back to node.data
            if (!node.data) node.data = {};
            if (!(totalPT === "" && totalAT === "")) {
                node.data[totalColKey] = JSON.stringify(totalMetrics);
                node.data[totalColKey + '_es'] = updateCellValue(node.data, totalColKey, 'value', totalMetrics, updatedByUser);
            }
            if (node.data && 'checkInAgentData' in node.data) {
                delete node.data['checkInAgentData'];
            }

            const startDate = node.data[startDateColumnField];
            const endDate = node.data[endDateColumnField];
            let updatedDuration = countWeekdays(startDate, endDate);
            node.data[durationColumn.field] = updatedDuration;
            node.data[durationColumn.field + '_es'] = updateCellValue(node.data, durationColumn.field, 'value', updatedDuration, updatedByUser);
            if (node.data && 'checkInAgentData' in node.data) {
                delete node.data['checkInAgentData'];
            }


        });


        const allChangedNodes = Array.from(filteredUpdatedNodes.keys());
        
        
        gridRef.current.api.applyTransaction({ update: allChangedNodes.map(node => node.data) });
        
        await updateCheckInAgentDataOnSheet(currentSelectedSheet.id, currentSelectedSheet.checkInAgentData)
        const updatedCellDataToSave = allChangedNodes.map(row => row.data);
        dispatch(categorizeAndStoreUpdatedRows({ update: updatedCellDataToSave },gridRef))
        
        setischeckInAgentRowsToBeMerged(false)
        if (updatedCellDataToSave)
            saveRowsViaUserActivity()
    } catch (error) {
        console.error("Error in mergeCheckInAgentData:", error);
    }
};

async function updateCheckInAgentDataOnSheet (sheetId, mergedCheckinAgentData){
    try {
        let sheetCheckinAgentData = await getSheetCheckInAgentData(sheetId);
        let updatedCheckInAgentData = removeMergedChanges(sheetCheckinAgentData, mergedCheckinAgentData);
        await updateCheckInAgentDataFromSheetAndSaveInSheet(sheetId, updatedCheckInAgentData);
    } catch (error) {
        console.error("Error in updateCheckInAgentDataOnSheet", error);
    }
}
  